var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppDialog',{attrs:{"disableMaxWidth":"","dialogName":_vm.dialogName,"width":"750"}},[(!_vm.project)?_c('div',[_vm._v("No space found")]):[_c('div',{staticClass:"content-wrapper pt-4 pb-7 px-9"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(this.project.title))]),_c('AppTabs',{staticClass:"pt-7",attrs:{"tabItems":_vm.tabItems}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }